import { t } from "../../../../utils/i18n";
import React from 'react';
import ActivateCard from './ActivateCard'; 
import '../../../P2PTrades/Offers/index.scss'; 
import "./activation-info-banner.css";

const Activations = ({ cardRequests }) => {
  // Determine if there are any cards that can be activated
  const activatableCards = cardRequests && cardRequests.filter(cr => cr.can_activate_card);
  const hasActivatableCards = activatableCards && activatableCards.length > 0;

  return (
    <div className="container-fluid px-2 px-md-4 py-4">
      {/* Page Header Section */}
      <div className="mb-4 p-3 bg-light rounded-lg shadow-sm">
        <h4 className="create-trade-page-title font-weight-bold">
          <i className="fa fa-bolt mr-2"></i>{t("cards.activations.title")}
        </h4>
        <p className="mb-0 text-muted">
          {hasActivatableCards 
            ? t("cards.activations.review") 
            : t("cards.activations.all_active")}
        </p>
      </div>

      {/* Activation info banner for users with pending activation */}
      {hasActivatableCards && (
        <div className="activation-info-banner mb-4">
          <div className="icon-box">
            <i className="fa fa-info-circle" />
            <h5>{t("cards.activations.info_title_1")}<br />{t("cards.activations.info_title_2")}</h5>
          </div>
          <div className="content-box">
            <p>{t("cards.activations.congrats")}</p>
            <p>{t("cards.activations.timing")}</p>
            <p className="mb-0">{t("cards.activations.how_to")}</p>
          </div>
        </div>
      )}

      {/* Section for ActivateCard components */}
      {cardRequests && cardRequests.length > 0 ? (
        <div className="row">
          {cardRequests.map((cardRequest, i) => (
            <div key={cardRequest.id || i} className="col-12 col-md-6 col-lg-4 mb-4">
              <ActivateCard
                cardRequest={cardRequest}
                cardStatus={cardRequest.card_detail?.status} 
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="modern-alert modern-alert-info">
          <i className="fa fa-info-circle mr-2"></i> {t("cards.activations.none")}
        </div>
      )}
    </div>
  );
};

export default Activations;
